import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

const InfoBar = props => (
  <Wrapper>
    <CardContainer>
      <Card>
        <CardHeader>Camp Director Recommendations</CardHeader>
        <CardText>
          The only website with camp recommendations by real summer camp
          directors.
        </CardText>
      </Card>
      <Divider />
      <Card>
        <CardHeader>Universal Camp Application</CardHeader>
        <CardText>
          Create your family's profile once with a single click contact any of
          hundreds of quality camps.
        </CardText>
      </Card>
      <Divider />
      <Card>
        <CardHeader>Summer Camp Profiles</CardHeader>
        <CardText>
          Get full camp profiles featuring consolidated, key information.
        </CardText>
      </Card>
    </CardContainer>
    <Button href="/users/sign_up">Register Now to Get Started</Button>
  </Wrapper>
)

const Button = glamorous.a({
  background: style.colors.primaryBlue,
  borderRadius: 10,
  color: "white",
  padding: 15,
  margin: "auto",
  textAlign: "center",
  display: "inline-block",
  width: "25%",
  textDecoration: "none",
  ":hover": {
    background: style.colors.darkerPrimaryBlue,
  },
  "@media (max-width: 750px)": {
    width: "80%",
    marginBottom: 20,
  },
})

const Card = glamorous.div({
  display: "inline-block",
  margin: "auto",
  width: "75%",
  padding: 30,
  "@media (max-width: 750px)": {
    paddingLeft: 0,
    paddingRight: 0,
  },
})

const CardContainer = glamorous.div({
  width: "100%",
  display: "flex",
  alignContent: "center",
  paddingLeft: 60,
  paddingRight: 60,
  backgroundSize: "cover",
  backgroundColor: "white",
  textAlign: "center",
  "@media (max-width: 1100px)": {
    flexDirection: "column",
  },
  "@media (max-width: 750px)": {
    padding: 0,
  },
})

const CardHeader = glamorous.h2({
  color: style.colors.forestGreen,
  textAlign: "center",
  fontSize: "1.5em",
  paddingBottom: 20,
})

const CardText = glamorous.p({
  textAlign: "center",
  padding: 10,
})

const Divider = glamorous.div({
  borderLeft: `1px solid ${style.colors.altVeryLightGray}`,
  "@media (max-width: 1100px)": {
    borderBottom: `1px solid ${style.colors.altVeryLightGray}`,
    width: "60%",
    margin: "auto",
  },
  "@media (max-width: 750px)": {
    width: "80%",
  },
})

const Wrapper = glamorous.div({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  padding: 60,
  "@media (max-width: 750px)": {
    padding: 30,
    paddingLeft: 0,
    paddingRight: 0,
  },
})

export default InfoBar



// WEBPACK FOOTER //
// ./src/scenes/Home/InfoBar.js